import * as Actions from "../actions";

const initialState = {
	success: false,
	countries: [],
	states: [],
	cities: [],
	error: {
		username: null,
		password: null,
	},
};

const register = (state = initialState, action) => {
	switch (action.type) {
		case Actions.REGISTER_SUCCESS: {
			return {
				...state,
				success: true,
			};
		}
		case Actions.REGISTER_ERROR: {
			return {
				success: false,
				error: action.payload,
			};
		}
		case Actions.GET_COUNTRIES: {
			return {
				...state,
				countries: action.payload,
			};
		}
		case Actions.GET_STATES: {
			return {
				...state,
				states: action.payload,
			};
		}
		case Actions.GET_CITIES: {
			return {
				...state,
				cities: action.payload,
			};
		}
		default: {
			return state;
		}
	}
};

export default register;
